export default "__VITE_ASSET__f9bbeca6__"